import { Switch, Route } from 'react-router-dom';

import ErrorBoundary from 'components/ErrorBoundary';

import PhaseOutPage from 'pages/PhaseOut';
import './App.scss';

import ReactGA from 'react-ga4';
import { GA4_JULO, APP_ENV } from 'configs';

if (APP_ENV == 'production') {
  ReactGA.initialize(GA4_JULO);
}

function App() {
  return (
    <ErrorBoundary>
      <Switch>
        <Route component={PhaseOutPage} />
      </Switch>
    </ErrorBoundary>
  );
}

export default App;
